export enum PurchaseOrderStatus {
    Submitted = 1,
    Approved = 2,
    ExtractedForPayment = 3,
    Voided = 4,
    Invoiced = 5,
    Requested = 6,
    Denied = 7,
    Returned = 8
}